export const CURRENT_SURVEY_VERSION = '1'

export enum FeedbackType {
  Chatbot = 'chatbot',
  AutoReply = 'auto_reply',
  Agent = 'agent',
}

export const PROVIDE_AUTOMATED_SUPPORT_FEEDBACK = 'provide_automated_support_feedback'
export const DENY_AUTOMATED_SUPPORT_FEEDBACK = 'deny_automated_support_feedback'
